import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import React from 'react';
// swiper
import SwiperCore, {
  Swiper as Pagination, Navigation,
} from 'swiper';
import Swiper, { ReactIdSwiperProps } from 'react-id-swiper';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/navigation/navigation.min.css';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { dateToStringWithDayOfWeek, numberWithComma } from '../utils/format';
import urls from '../utils/urls';
import { RootState } from '../rootReducer';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  open: boolean
  onClose: React.ReactEventHandler<{}>
};
const TutorialModal: React.FC<Props> = (props) => {
  const {
    open, onClose, ...elementProps
  } = props;

  const {
    selectedBankInfo,
  } = useSelector((state: RootState) => state.top);

  const fadeSetting = {
    enter: 1000,
    exit: 0,
  };

  const createFirstRepaymentBloack = () => {
    if (selectedBankInfo.自振現状区分 === '1') {
      return (
        <div className="swiper-slide">
          <div className="tutorialBox">
            <p className="label fs4XL font-lakegreen mtFLAT">初回のご返済について</p>
            <div className="card bg-light-alsalightgreen mbXS">
              <p>お客さまは、<strong className="font-red">口座振替</strong>です。</p>
              <p className="aL mb2XS">初回ご返済内容</p>
              <p className="aL mtFLAT">引落し予定日：<strong>{dateToStringWithDayOfWeek(selectedBankInfo.次回支払年月日)}</strong><br />
                ご返済額：<strong>{numberWithComma(selectedBankInfo.毎回額)}円</strong>
              </p>
            </div>
            <div className="floL mr05gd">
              <img src="img/A/TT005/img_tutorial2.png" width="100" alt="初回のご返済について" />
            </div>
            <div className="floR">
              <div className="aL">
                <p className="mtFLAT mbXS">引落し予定日前日までにご登録の口座に、引落し金額のご準備をお願いします。</p>
                <ul className="listNote mb05gd">
                  <li className="listNote__item">ご返済が遅延した場合、無利息期間が終了するためご注意ください。</li>
                </ul>
              </div>
            </div>
            <div className="tutorialBox__btn">
              <div className="mb2XS">
                <button className="btn btn--cv swiper--next">次へ</button>
              </div>
              <button className="btn btn--text swiper--prev">戻る</button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="swiper-slide">
        <div className="tutorialBox">
          <p className="label fs4XL font-lakegreen mtFLAT">初回のご返済について</p>
          <div className="card bg-light-alsalightgreen mbXS">
            <p>お客さまは、<strong className="font-red">口座振替未登録</strong>です。</p>
            <p>ご返済期日までに、<br className="forSP" /><strong>以下に記載の方法でご返済</strong><br className="forSP" />をお願いします。</p>
          </div>
          <div className="floL mr05gd">
            <img src="img/A/TT005/img_tutorial2.png" width="100" alt="初回のご返済について" />
          </div>
          <div className="floR">
            <div className="aL">
              <ul className="list">
                <li className="list__item">Web返済サービス</li>
                <li className="list__item">Pay払い</li>
                <li className="list__item">スマホATM取引</li>
                <li className="list__item">銀行振込み</li>
              </ul>
              <p className="mtFLAT mbXS">などでご返済が可能です。</p>
              <ul className="listNote mb05gd">
                <li className="listNote__item">ご返済が遅延した場合、無利息期間が終了するためご注意ください。</li>
              </ul>
            </div>
          </div>
          <div className="tutorialBox__btn">
            <div className="mb2XS">
              <button className="btn btn--cv swiper--next">次へ</button>
            </div>
            <button className="btn btn--text swiper--prev">戻る</button>
          </div>
        </div>
      </div>
    );
  };

  // swiper設定
  const swiperParams: ReactIdSwiperProps = {
    containerClass: 'swiper',
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper--next',
      prevEl: '.swiper--prev',
    },
  };
  SwiperCore.use([Pagination, Navigation]);

  return (
    <Modal
      {...elementProps}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      open={open}
      onClose={onClose}
      className="modaal-wrapper modaal-inline modal--full"
    >
      <Fade in={open} timeout={fadeSetting}>
        <div className="modaal-outer-wrapper">
          <div className="modaal-inner-wrapper">
            <div className="modaal-container">
              <div className="modaal-content">
                <div className="modaal-content-container">
                  <div className="swiper">
                    <div className="swiper-wrapper">
                      <Swiper {...swiperParams}>
                        <div className="swiper-slide">
                          <div className="tutorialBox">
                            <div className="tutorialBox__img">
                              <img src="img/A/TT005/img_tutorial1.png" width="115" alt="レイクをお選びいただきありがとうございます。" />
                            </div>
                            <p className="label fs4XL font-lakegreen">レイクをお選びいただき<br />ありがとうございます。 </p>
                            <p>会員ページの便利なサービスを<br className="forSP" />ご紹介します。</p>
                            <div className="tutorialBox__btn">
                              <button className="btn btn--cv swiper--next">次へ</button>
                            </div>
                          </div>
                        </div>
                        {createFirstRepaymentBloack()}
                        <div className="swiper-slide swiper-slide--hasClose">
                          <div className="tutorialBox">
                            <p className="label fs4XL font-lakegreen mtFLAT">お借入れ</p>
                            <div className="tutorialBox__img">
                              <img src="img/A/TT005/img_tutorial3.png" width="132" alt="お借入れ" />
                            </div>
                            <p>お借入れ中でも、<strong>追加のお借入れ</strong>や<br /><strong>ご利用限度額の増額</strong>の審査申込みができます。</p>
                            <div className="tutorialBox__btn">
                              <div className="mb2XS">
                                <button className="btn btn--cv swiper--next">次へ</button>
                              </div>
                              <button className="btn btn--text swiper--prev">戻る</button>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide swiper-slide--hasClose">
                          <div className="tutorialBox">
                            <p className="label fs4XL font-lakegreen mtFLAT">ご返済</p>
                            <div className="tutorialBox__img">
                              <img src="img/A/TT005/img_tutorial4.png" width="213" alt="ご返済" />
                            </div>
                            <p><strong>次回のご返済予定日の登録・確認</strong>や<br /><strong>毎月のご返済日の変更</strong>が可能です。</p>
                            <div className="tutorialBox__btn">
                              <div className="mb2XS">
                                <button className="btn btn--cv swiper--next">次へ</button>
                              </div>
                              <button className="btn btn--text swiper--prev">戻る</button>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide swiper-slide--hasClose">
                          <div className="tutorialBox">
                            <p className="label fs4XL font-lakegreen mtFLAT">各種お手続き</p>
                            <div className="tutorialBox__img">
                              <img src="img/A/TT005/img_tutorial5.png" width="200" alt="各種お手続き" />
                            </div>
                            <p><strong>収入証明書類の提出</strong>や、<br /><strong>メールアドレス・ご自宅・お勤め先などのお客さま情報</strong>の変更が可能です。</p>
                            <div className="tutorialBox__btn">
                              <div className="mb2XS">
                                <button className="btn btn--cv swiper--next">次へ</button>
                              </div>
                              <button className="btn btn--text swiper--prev">戻る</button>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide swiper-slide--hasClose">
                          <div className="tutorialBox tutorialBox--last">
                            <div className="tutorialBox--last__inner">
                              <div className="tutorialBox__img">
                                <img src="img/A/TT005/img_tutorial6.png" width="240" alt="レイク｜SBI新生銀行グループ" />
                              </div>
                              <div className="mb2XS forPC">
                                <Link to={urls.TOP} className="btn btn--cv">会員ページへ</Link>
                              </div>
                            </div>
                            <div className="tutorialBox__btn">
                              <div className="mb2XS">
                                <Link to={urls.TOP} className="btn btn--cv">会員ページへ</Link>
                              </div>
                              <button className="btn btn--text swiper--prev">戻る</button>
                            </div>
                          </div>
                        </div>
                      </Swiper>
                    </div>
                    <div className="swiper-pagination" />
                    <div className="swiper-navigation">
                      <div className="swiper--next">次へ</div>
                      <div className="swiper--prev">戻る</div>
                    </div>
                  </div>
                </div>
              </div>
              <button className="modaal-close" onClick={onClose}><span>close</span></button>
            </div>
          </div>
          <button className="modaal-close" onClick={onClose} style={{ display: 'inline-block' }}><span>close</span></button>
        </div>
      </Fade>
    </Modal>
  );
};

export default TutorialModal;
